import { FilterService } from '~/utils/filter.service';
export default function (_a) {
    var store = _a.store;
    return FilterService;
}
